jQuery(document).ready(function ($) {
	const $footerItems = $(".footer-item");
	const $toggleButtons = $(".footer-nav-toggle");

	$toggleButtons.on("click", function () {
		const $button = $(this);
		const $item = $button.closest(".footer-item");
		const $content = $item.find(".footer-col");
		const isContentVisible = $content.is(":visible");

		// Hide all contents and reset buttons
		$footerItems.find(".footer-col").slideUp(200);
        $toggleButtons.attr('data-active', false);

		// If the clicked content wasn't visible, show it
		if (!isContentVisible) {
			$content.slideDown(200);
            $button.attr('data-active', true);
		}
	});
});
